module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-nav', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "light"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n          ")], 1)], 1), _vm._v(" "), _c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v(_vm._s(_vm.$route.name))]), _vm._v(" "), _c('b-navbar-nav', {
    staticClass: "ml-auto"
  })], 1), _vm._v(" "), _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }), _vm._v(" "), _c('b-col', {
    staticClass: "text-right",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "12"
    }
  }, [_c('b-card', {
    staticClass: "formCard"
  }, [_c('b-card-text', [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "caf_tpt_type"
    }
  }, [_vm._v("Transportation By "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('model-list-select', {
    style: ({
      borderColor: !_vm.form.caf_tpt_type && _vm.errorList.caf_tpt_type ? 'red' : '',
    }),
    attrs: {
      "isDisabled": _vm.form.caf_id > 0 && _vm.$sessionsStorage.get('nameUser') != 'Bhavneesh' ? true : false,
      "list": _vm.TPTtypeList,
      "option-value": "ccTypeVal",
      "option-text": "ccTypeTxt",
      "placeholder": "Select Transportation By"
    },
    model: {
      value: (_vm.form.caf_tpt_type),
      callback: function($$v) {
        _vm.$set(_vm.form, "caf_tpt_type", $$v)
      },
      expression: "form.caf_tpt_type"
    }
  }), _vm._v(" "), (!_vm.form.caf_tpt_type) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorList.caf_tpt_type))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "caf_transport_type"
    }
  }, [_vm._v("Movement Type "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('model-list-select', {
    style: ({
      borderColor: !_vm.form.caf_transport_type && _vm.errorList.caf_transport_type ? 'red' : '',
    }),
    attrs: {
      "isDisabled": _vm.form.caf_id > 0 &&
        _vm.$sessionsStorage.get('nameUser') != 'Bhavneesh' ?
        true : false,
      "list": _vm.movementTypeList,
      "option-value": "val",
      "option-text": "text",
      "placeholder": "Select "
    },
    model: {
      value: (_vm.form.caf_transport_type),
      callback: function($$v) {
        _vm.$set(_vm.form, "caf_transport_type", $$v)
      },
      expression: "form.caf_transport_type"
    }
  }), _vm._v(" "), (!_vm.form.caf_transport_type) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorList.caf_transport_type))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "3"
    }
  }, [_c('label', [_vm._v("CAF Date")]), _vm._v(" "), (_vm.$sessionsStorage.get('designation') == 'Admin' && _vm.$sessionsStorage.get('nameUser') == 'Bhavneesh') ? _c('date-picker', {
    style: ({
      borderColor: !_vm.form.caf_date && _vm.errorList.caf_date ? 'red' : '',
    }),
    attrs: {
      "disabled": _vm.form.caf_id > 0 && _vm.$sessionsStorage.get('nameUser') != 'Bhavneesh' ? true : false,
      "format": _vm.selectDateFormat,
      "lang": "en",
      "width": "100%",
      "type": "date",
      "id": "caf_date",
      "placeholder": "GRN Date"
    },
    model: {
      value: (_vm.form.caf_date),
      callback: function($$v) {
        _vm.$set(_vm.form, "caf_date", $$v)
      },
      expression: "form.caf_date"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.form.caf_date) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorList.caf_date))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "fk_cont_type_id"
    }
  }, [_vm._v("Container Type. "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('model-list-select', {
    style: ({
      borderColor: !_vm.form.fk_cont_type_id && _vm.errorList.fk_cont_type_id ? 'red' : '',
    }),
    attrs: {
      "list": _vm.$store.getters['common/getAllContainerTypeList'],
      "isDisabled": _vm.form.caf_id > 0 ? true : false,
      "option-value": "containerTypeId",
      "option-text": "containerType",
      "placeholder": "Select Container Type"
    },
    model: {
      value: (_vm.form.fk_cont_type_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "fk_cont_type_id", $$v)
      },
      expression: "form.fk_cont_type_id"
    }
  }), _vm._v(" "), (!_vm.form.fk_cont_type_id) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorList.fk_cont_type_id))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "fk_client_id"
    }
  }, [_vm._v("Shipper Name. "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('model-list-select', {
    style: ({
      borderColor: !_vm.form.fk_client_id && _vm.errorList.fk_client_id ? 'red' : '',
    }),
    attrs: {
      "list": _vm.$store.getters['common/getAllClientList'],
      "id": "clientform",
      "option-value": "clientId",
      "option-text": "clientName",
      "placeholder": "Select SHIPPER",
      "required": ""
    },
    on: {
      "input": function($event) {
        _vm.getStuffingLocation($event)
      }
    },
    model: {
      value: (_vm.form.fk_client_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "fk_client_id", $$v)
      },
      expression: "form.fk_client_id"
    }
  }), _vm._v(" "), (!_vm.form.fk_client_id) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorList.fk_client_id))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "fk_vehicle_id"
    }
  }, [_vm._v("Vehicle No. "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('model-list-select', {
    style: ({
      borderColor: !_vm.form.fk_vehicle_id && _vm.errorList.fk_vehicle_id ? 'red' : '',
    }),
    attrs: {
      "list": _vm.$store.getters['commonDropdownMaster/getAllVehicleDDList'],
      "option-value": "value",
      "option-text": "label",
      "placeholder": "Select Vehicle No"
    },
    model: {
      value: (_vm.form.fk_vehicle_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "fk_vehicle_id", $$v)
      },
      expression: "form.fk_vehicle_id"
    }
  }), _vm._v(" "), (!_vm.form.fk_vehicle_id) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorList.fk_vehicle_id))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "fk_from_id"
    }
  }, [_vm._v("From "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('model-list-select', {
    style: ({
      borderColor: !_vm.form.fk_from_id && _vm.errorList.fk_from_id ? 'red' : '',
    }),
    attrs: {
      "list": _vm.$store.getters['common/getAllPORList'],
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select From"
    },
    on: {
      "input": function($event) {
        _vm.getLocationList($event, 'All', 'finalAllPlaceDataPOR')
      },
      "searchchange": function($event) {
        _vm.getLocationList($event, 'All', 'finalAllPlaceDataPOR')
      }
    },
    model: {
      value: (_vm.form.fk_from_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "fk_from_id", $$v)
      },
      expression: "form.fk_from_id"
    }
  }), _vm._v(" "), (!_vm.form.fk_from_id) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorList.fk_from_id))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "fk_to_id"
    }
  }, [_vm._v("To "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('model-list-select', {
    style: ({
      borderColor: !_vm.form.fk_to_id && _vm.errorList.fk_to_id ? 'red' : '',
    }),
    attrs: {
      "list": _vm.$store.getters['commonDropdownMaster/getAllStuffingList'],
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select To"
    },
    model: {
      value: (_vm.form.fk_to_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "fk_to_id", $$v)
      },
      expression: "form.fk_to_id"
    }
  }), _vm._v(" "), (!_vm.form.fk_to_id) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorList.fk_to_id))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    staticClass: "justify-content-center mt-2",
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "12"
    }
  }, [_c('b-button', {
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "size": "xxl",
      "disabled": _vm.isSubmited,
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        _vm.saveContainerAllocation(0)
      }
    }
  }, [(_vm.isSubmited) ? _c('md-spinner', {
    staticStyle: {
      "width": "20px",
      "height": "20px"
    },
    attrs: {
      "md-indeterminate": ""
    }
  }) : _vm._e(), _vm._v("\n                      " + _vm._s(_vm.form.caf_id > 0 ? 'Update' : 'Save') + "\n                    ")], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4a069fd6","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/view/vehicleQuotation/containerAllocationForm.vue
// module id = 2596
// module chunks = 0